import { galleryImages } from '@/mocks/homeData';

export default function FactoryGallery() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F9FC]">
      <div className="section-container">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
            Factory Gallery
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            Inside Our<br />Manufacturing Facility
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            Take a glimpse inside our state-of-the-art production floors, quality labs, and warehouse operations.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className={`break-inside-avoid group relative overflow-hidden rounded-lg cursor-pointer animate-on-scroll animate-on-scroll-delay-${(i % 5) + 1}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-primary-900/0 group-hover:bg-primary-900/20 transition-colors duration-300 flex items-end">
                <div className="p-4 w-full translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="text-white text-xs font-medium">{img.alt}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}